module.exports = __webpack_public_path__ + "statics/img/01.b485f183.png";